<div class="trip-details-container" [class.collapsed]="!trip">
    <div class="trip-details" *ngIf="trip">

        <div class="trip-details-main-info">
            <div class="trip-details-header">
                <label [i18n]="'realtime-tracking.load-tracking-map.trip-details.title'"></label>

                <button class="btn btn-default dim"
                        *ngIf="!singleTrip && trip.status !== TripStatus.COMPLETED && trip.status !== TripStatus.EXPIRED"
                        (click)="openNotification(notificationModal, trip)"
                        [i18n]="[{target: 'attribute:title', key: 'realtime-tracking.load-tracking-map.trip-details.notifications.tooltip'}]">
                    <i class="fas fa-comment dim"></i>
                </button>

                <button class="btn btn-warning dim"
                        *ngIf="!singleTrip && trip.status !== TripStatus.COMPLETED  && trip.status !== TripStatus.EXPIRED"
                        (click)="openConfirmCloseSelectedTrip(confirmCloseTripModal)"
                        [i18n]="[{target: 'attribute:title', key: 'realtime-tracking.load-tracking-map.trip-details.close.tooltip'}]"
                        [disabled]="trip.status === TripStatus.COMPLETED || trip.status === TripStatus.EXPIRED">
                    <i class="fa fa-lock"></i>
                </button>

                <button class="btn btn-default dim" *ngIf="!singleTrip"
                        (click)="copyCustomerLink()"
                        [i18n]="[{target: 'attribute:title', key: 'realtime-tracking.load-tracking-map.trip-details.link.tooltip'}]">
                    <i class="fa fa-link"></i>
                </button>

                <button class="btn btn-default dim"
                        *ngIf="trip.status !== TripStatus.COMPLETED || trip.status !== TripStatus.EXPIRED "
                        (click)="refreshTripDetails()"
                        [i18n]="[{target: 'attribute:title', key: 'realtime-tracking.load-tracking-map.trip-details.refresh.tooltip'}]">
                    <i class="fa fa-refresh"></i>
                </button>
            </div>

            <div class="trip-details-ids">
                <span class="trip-details-delivery-number m-r-xs text-overflow-ellipsis"
                      [popover]="salesOrderPopTemplate"
                      placement="bottom" container="body"
                      triggers="mouseenter:mouseleave">
                    <span [i18n]="'realtime-tracking.common.delivery'"></span>&nbsp;
                    <label class="badge badge-link">
                    <a class="cmaweb-link" [href]="link.goToLoadManagementForDelivery(trip.deliveryNumbersInline)"
                       target="_blank">{{ trip.deliveryNumbersInline }}</a></label>
                </span>
                <ng-template #salesOrderPopTemplate>
                    <chp-delivery-and-sales-order-numbers
                        [deliveryNumbers]="trip.deliveryNumbers"
                        [salesOrderNumbers]="trip.getSalesOrderNumbers()">
                    </chp-delivery-and-sales-order-numbers>
                </ng-template>
                <span class="trip-details-load-number" [title]="trip.loadNumber">
                    <span [i18n]="'realtime-tracking.common.load'"></span>&nbsp;
                    <label class="badge badge-link">
                    <a class="cmaweb-link" [href]="link.goToLoadManagementForLoad(trip.loadNumber)"
                       target="_blank">{{ trip.loadNumber }}</a></label>
                </span>
            </div>

            <div class="trip-details-info">
                <div class="trip-details-status">
                    <div class="trip-details-status-info">
                        <span class="trip-status">
                            <span [i18n]="'realtime-tracking.common.status'"></span>:
                            <span class="status"
                                  [ngClass]="[trip.status | lowercase]"
                                  [i18n]="('realtime-tracking.common.trip-status.'+(trip.status | lowercase))">
                            </span>
                        </span>
                        <span class="trip-status-duration" *ngIf="trip.status !== TripStatus.IN_PROGRESS && !singleTrip && tripStatusInfo.duration">
                            <span class="m-r-xs" [i18n]="tripStatusInfo.isHandover ?
                              'realtime-tracking.common.load-handover.since' :
                              'realtime-tracking.load-tracking-map.trip-details.common.duration'">
                            </span>
                            <span class="blue">{{ tripStatusInfo.duration }}</span>
                        </span>
                    </div>
                </div>

                <div class="trip-vehicles"
                     [i18n]="[{ target: 'innerHTML', key: 'realtime-tracking.load-tracking-map.trip-details.vehicles', params: { vehicles: tripVehicles }}]"></div>

                <div class="trip-planned-info">
                    <div class="title" *ngIf="trip.loadPlanningEnd"
                         [i18n]="'realtime-tracking.load-tracking-map.trip-details.planned'"></div>
                    <div class="title" *ngIf="!trip.loadPlanningEnd"
                         [i18n]="'realtime-tracking.load-tracking-map.trip-details.unknown'"></div>
                    <div *ngIf="!trip.timezone && singleTrip" class="trip-tooltip">
                        <i class="fa fa-info-circle space-right-5"></i>
                        <div>
                            <span [i18n]="'realtime-tracking.load-tracking-map.trip-details.no-trip-timezone'"></span>
                        </div>
                    </div>
                    <div class="content trip-details-timeZone" *ngIf="trip.loadPlanningEnd">
                        <div class="blue">
                            <app-timezone-date
                                [dateFormat]="dateFormat"
                                [displayBothDates]="false"
                                [displayLogo]="false"
                                [time]="trip.loadPlanningStart">
                            </app-timezone-date>
                        </div>
                        <div class="separation">
                            <i class="fas fa-caret-right"></i>
                            <i class="fas fa-caret-left"></i>
                        </div>
                        <div class="blue">
                            <app-timezone-date
                                [dateFormat]="dateFormat"
                                [displayBothDates]="false"
                                [displayLogo]="false"
                                [time]="trip.loadPlanningEnd"
                                [alignRight]="true">
                            </app-timezone-date>
                        </div>
                    </div>
                </div>
                <div class="trip-details-global-info">
                    <div class="trip-details-labels">
                        <span [i18n]="'realtime-tracking.load-tracking-map.trip-details.common.recorded'"></span>
                        <span *ngIf="trip.isCompleted()"
                              [i18n]="'realtime-tracking.load-tracking-map.trip-details.common.completed'"></span>
                        <span *ngIf="trip.isExpired()"
                              [i18n]="'realtime-tracking.load-tracking-map.trip-details.common.expired'"></span>
                        <span *ngIf="!trip.isCompleted() && !trip.isExpired() && !singleTrip && latestEta"
                              [i18n]="'realtime-tracking.load-tracking-map.trip-details.eta-label'"></span>
                    </div>
                    <div class="dates trip-details-timeZone">
                        <span class="blue" *ngIf="tripStartFormat"
                              [title]="(tripStartDuration | translateDuration) | async">
                            <app-timezone-date
                                [dateFormat]="dateFormat"
                                [displayBothDates]="false"
                                [displayLogo]="false"
                                [time]="tripStartDate">
                            </app-timezone-date></span>
                        <span class="blue" *ngIf="!tripStartFormat"
                              [title]="timeZoneService.utcToCurrentTimezone(tripStartDate).format('D MMM LT (z)')">
                            {{ (tripStartDuration | translateDuration) | async}}
                        </span>
                        <div class="separation" *ngIf="!singleTrip && latestEta || trip.isCompleted() || trip.isExpired() ">
                            <i class="fas fa-caret-right"></i>
                            <i class="fas fa-caret-left"></i>
                        </div>
                        <span class="blue" *ngIf="trip.isCompleted() || trip.isExpired()">
                            <span *ngIf="tripEndFormat" [title]="(tripEndDuration | translateDuration) | async">
                                <app-timezone-date
                                    [dateFormat]="dateFormat"
                                    [displayBothDates]="false"
                                    [displayLogo]="false"
                                    [time]="tripEndDate"
                                    [alignRight]=" true">
                                </app-timezone-date></span>
                            <span class="blue" *ngIf="!tripEndFormat"
                                  [title]="timeZoneService.utcToCurrentTimezone(tripEndDate).format('D MMM LT (z)')">
                                {{ (tripEndDuration | translateDuration) | async }}
                            </span>
                        </span>

                        <span class="text-right" *ngIf="!trip.isCompleted() && !trip.isExpired() && !singleTrip && latestEta">
                            <span class="blue" *ngIf="etaFormat"
                                  [title]="(etaDuration | translateDuration : etaOverCap) | async">
                                <app-timezone-date
                                    [dateFormat]="dateFormat"
                                    [displayBothDates]="false"
                                    [displayLogo]="false"
                                    [time]="latestEta"
                                    [alignRight]=" true">
                                </app-timezone-date>
                            </span>
                            <span class="blue" *ngIf="!etaFormat"
                                  [title]="timeZoneService.utcToCurrentTimezone(latestEta).format('D MMM LT (z)')">
                                {{ (etaDuration | translateDuration : etaOverCap) | async }}
                            </span>
                        </span>
                    </div>
                    <span class="last-eta-update" *ngIf="trip.isInProgress() && !singleTrip && latestEtaUpdatedAt">
                        <span>(</span>
                        <span [i18n]="'realtime-tracking.load-tracking-map.trip-details.common.changed'"></span>&nbsp;
                        <span class="blue" *ngIf="etaUpdatedAtFormat"
                              [title]="(etaUpdatedAtDuration | translateDuration) | async">
                            <app-timezone-date
                                [dateFormat]="dateFormat"
                                [displayBothDates]="false"
                                [displayLogo]="false"
                                [time]="latestEtaUpdatedAt"
                                [alignRight]=" true">
                            </app-timezone-date>
                        </span>
                        <span class="blue" *ngIf="!etaUpdatedAtFormat"
                              [title]="timeZoneService.utcToCurrentTimezone(latestEtaUpdatedAt).format('D MMM LT (z)')">
                            {{ (etaUpdatedAtDuration | translateDuration) | async}}
                        </span>
                        <span>)</span>
                    </span>
                </div>

                <div class="trips-details-latest-ping-statuses"
                     *ngIf="trip.latestPing?.statuses.length > 0 && !singleTrip">
                    <span [i18n]="'realtime-tracking.load-tracking-map.trip-details.state'"></span>

                    <span *ngFor="let status of trip.latestPing.statuses" class="label label-info text-lowercase m-r-xs"
                          [i18n]="'realtime-tracking.common.pings-status.' + status">
                    </span>
                </div>
            </div>
        </div>

        <div class="trip-details-additional-info">
            <div class="trip-details-locations">
                <app-trip-address *ngIf="!singleTrip"
                                  [iconUrl]="trip.originLocationType === 'CHEP' ? chepDepartureIconUrl : customerDepartureIconUrl"
                                  (click)="goToMarker([trip.originPosition.lat, trip.originPosition.lng])">
                    <app-trip-address-row [isPrimary]="true">
                        {{ trip.originAddress }}
                    </app-trip-address-row>
                    <app-trip-address-row>
                        {{ trip.originCity + ' ' + trip.originPostalCode }}
                    </app-trip-address-row>
                    <app-trip-address-row>
                        {{ trip.originRegionName ? trip.originRegionName + ' - ' + trip.originCountryCode : trip.originCountryCode }}
                    </app-trip-address-row>
                </app-trip-address>

                <app-trip-address *ngIf="tripStatusInfo.isHandover"
                                  [iconUrl]="passiveTrailerIconUrl"
                                  (click)="goToMarker([trip.destPosition.lat, trip.destPosition.lng])">
                    <app-trip-address-row [isPrimary]="true">
                        <span [i18n]="'realtime-tracking.common.last-ping'"></span>
                    </app-trip-address-row>
                    <app-trip-address-row>
                        <span>
                            {{ (lastPingDuration | translateDuration) | async }}
                        </span>
                    </app-trip-address-row>
                    <app-trip-address-row>
                        <span>
                            {{ lastPingDistance + (distanceUnit === 'KILOMETERS' ? ' km' : ' mi') }}
                            <span [i18n]="'realtime-tracking.load-tracking-map.trip-details.common.away'"></span>
                        </span>
                    </app-trip-address-row>
                </app-trip-address>

                <div class="trip-details-events" *ngFor="let event of events; index as i">
                    <app-trip-address [iconUrl]="event.type === TripEventType.HANDOVER_RELEASE ? passiveReleaseIconUrl :
                                                 event.type === TripEventType.HANDOVER_TAKE ? passivePickIconUrl :
                                                 event.type === TripEventType.CHECKIN ? passiveCheckInIconUrl : passiveCheckOutIconUrl">
                        <app-trip-address-row [isPrimary]="true">
                            <span *ngIf="event.type === TripEventType.HANDOVER_RELEASE"
                                  [i18n]="'realtime-tracking.common.load-handover.released'"></span>
                            <span *ngIf="event.type === TripEventType.HANDOVER_TAKE"
                                  [i18n]="'realtime-tracking.common.load-handover.taken'"></span>
                            <span *ngIf="event.type === TripEventType.CHECKIN"
                                  [i18n]="'realtime-tracking.common.checkin'"></span>
                            <span *ngIf="event.type === TripEventType.CHECKOUT"
                                  [i18n]="'realtime-tracking.common.checkout'"></span>
                        </app-trip-address-row>
                        <app-trip-address-row>
                            <app-timezone-date
                                [dateFormat]="dateFormat"
                                [displayBothDates]="false"
                                [displayLogo]="false"
                                [time]="eventsDate[i]">
                            </app-timezone-date>
                            <span
                                *ngIf="event.type === TripEventType.HANDOVER_RELEASE || event.type === TripEventType.HANDOVER_TAKE">
                                  &nbsp;<span
                                [i18n]="[{target: 'innerHTML', key: 'realtime-tracking.common.load-handover.by-vehicle', params: { vehicle: getHandoverVehicleForEvent(event) }}]"></span>
                            </span>
                        </app-trip-address-row>
                        <app-trip-address-row>
                            <span>
                                {{ (eventsDuration[i] | translateDuration) | async}}
                            </span>
                        </app-trip-address-row>
                        <app-trip-address-row></app-trip-address-row>
                    </app-trip-address>
                </div>

                <app-trip-address *ngIf="!trip.isCompleted() && !tripStatusInfo.isHandover && trip.latestPing"
                                  [iconUrl]="passiveTrailerIconUrl"
                                  (click)="goToMarker([trip.latestPing.latitude, trip.latestPing.longitude])">
                    <app-trip-address-row [isPrimary]="true">
                        <span [i18n]="'realtime-tracking.common.last-ping'"></span>
                    </app-trip-address-row>
                    <app-trip-address-row>
                        <span>
                            {{ (lastPingDuration | translateDuration) | async}}
                        </span>
                    </app-trip-address-row>
                    <app-trip-address-row>
                        <span>
                            {{ lastPingDistance + (distanceUnit === 'KILOMETERS' ? ' km' : ' mi') }}
                            <span [i18n]="'realtime-tracking.load-tracking-map.trip-details.common.away'"></span>
                        </span>
                    </app-trip-address-row>
                </app-trip-address>

                <app-trip-address
                    [iconUrl]="trip.destLocationType == 'CHEP' ? chepArrivalIconUrl : customerArrivalIconUrl"
                    (click)="goToMarker([trip.destPosition.lat, trip.destPosition.lng])">
                    <app-trip-address-row [isPrimary]="true">
                        {{ trip.destAddress }}
                    </app-trip-address-row>
                    <app-trip-address-row>
                        {{ trip.destCity + ' ' + trip.destPostalCode }}
                    </app-trip-address-row>
                    <app-trip-address-row>
                        {{ trip.destRegionName ? trip.destRegionName + ' - ' + trip.destCountryCode : trip.destCountryCode }}
                    </app-trip-address-row>
                </app-trip-address>
            </div>

            <div class="trip-details-devices" *ngIf="debug && trip.achievedPaths.length > 0">
                <div class="trip-details-device" *ngFor="let devicePaths of trip.achievedPaths">
                    <div class="checkbox">
                        <label>
                            <input type="checkbox" name="show-device-paths" [(ngModel)]="devicePaths.displayed">
                            <i class="fa checkbox-icon"></i>
                            <span [i18n]="[{target: 'innerHTML', key: 'realtime-tracking.load-tracking-map.trip-details.devices.device-id',
                              params: { deviceId: devicePaths.deviceId }
                                }]">
                            </span>
                        </label>
                    </div>

                    <div class="m-l-md">
                        <div class="checkbox">
                            <label>
                                <input type="checkbox" name="select-all-paths"
                                       [(ngModel)]="devicePaths.selectAllPaths"
                                       (change)="checkAllPaths(devicePaths)">
                                <i class="fa checkbox-icon"></i>
                                <span
                                    [i18n]="'realtime-tracking.load-tracking-map.trip-details.devices.select-all'"></span>
                            </label>
                        </div>
                        <div *ngFor="let path of devicePaths.paths; let i = index">
                            <div class="checkbox">
                                <label>
                                    <input type="checkbox" name="show-path" [(ngModel)]="path.displayed"
                                           (change)="checkPath(devicePaths)">
                                    <i class="fa checkbox-icon"></i>
                                    <span [i18n]="[{target: 'innerHTML', key: 'realtime-tracking.load-tracking-map.trip-details.devices.pings-count-and-duration',
                                      params: { count: path.pings.length, duration: (path.durationInSec() | secondsDuration | async) }
                                        }]">
                                    </span>
                                </label>
                            </div>
                            <div *ngIf="devicePaths.paths[i + 1]">
                                <span [i18n]="[{target: 'innerHTML', key: 'realtime-tracking.load-tracking-map.trip-details.devices.time-ellapsed',
                                  params: { duration: (devicePaths.paths[i + 1].firstPing.createdAt.diff(path.lastPing.createdAt, 'minutes') | secondsDuration | async) }
                                    }]">
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="trip-customer-info" *ngIf="singleTrip">
            <div class="trip-delay-status">
                <span class="delay-status" [ngClass]="[tripDelayStatus | lowercase]"
                      [i18n]="'realtime-tracking.common.trip-status.'+tripDelayStatus | lowercase"></span>
            </div>
            <div class="eta-info" *ngIf="trip.isInProgress()">
                <div class="eta-info-container">
                    <span class="eta-label"
                          [i18n]="'realtime-tracking.load-tracking-map.trip-details.eta-label'"></span>
                </div>
                <div class="line text-right" *ngIf="latestEta">
                    <span class="eta">{{ timeZoneService.utcToCurrentTimezone(latestEta)?.format('LT (z)') }}</span>
                    <div class="eta-diff-from-now ">
                        {{ (etaDuration | translateDuration : etaOverCap) | async }}
                    </div>
                    <div class="eta-updated-at" *ngIf="!!latestEtaUpdatedAt">
                        <span [i18n]="'realtime-tracking.load-tracking-map.trip-details.eta-update'"></span>
                        <span class="blue"> {{ timeZoneService.utcToCurrentTimezone(latestEtaUpdatedAt)?.format('D MMM LT (z)')}}</span>
                    </div>
                </div>
                <div class="line text-right" *ngIf="!latestEta">
                    <span [i18n]="'realtime-tracking.load-tracking-map.trip-details.unknown'"></span>
                </div>
                <div class="latest-eta-diff-from-eta text-right" *ngIf="etaDiff">
                    <span class="blue">{{ etaDiff }} </span>
                    <span [i18n]="'realtime-tracking.load-tracking-map.trip-details.common.after'"
                          *ngIf="firstEtaOrigin === 'provided'"></span>
                    <span [i18n]="'realtime-tracking.load-tracking-map.trip-details.common.before'"
                          *ngIf="firstEtaOrigin === 'current'"></span>
                    <span>&nbsp;</span>
                    <span [i18n]="'realtime-tracking.load-tracking-map.trip-details.common.deadline'"></span>
                </div>
            </div>
            <div class="completed-info" *ngIf="trip.isCompleted() || trip.isExpired()">
                <div class="completed-info-container">
                    <div class="completed-label"
                          [i18n]="'realtime-tracking.load-tracking-map.trip-details.common.completed'"></div>
                    <div class="completed"
                          [title]="tripEndDuration"> {{timeZoneService.utcToCurrentTimezone(trip.completedAt)?.format('D MMM LT (z)') }}</div>
                </div>
                <div class="duration text-right">
                    <div>
                        <span [i18n]="'realtime-tracking.load-tracking-map.trip-details.common.duration'"></span>
                        <span class="blue"> {{ tripStatusInfo.duration }}</span>
                    </div>
                    <div class="late-info text-right" *ngIf="tripDelayStatus === TripDelayStatus.LATE">
                        <span class="blue"> {{ delayDuration }} </span>
                        <span [i18n]="'realtime-tracking.load-tracking-map.trip-details.common.late'"></span>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>


<ng-template #confirmCloseTripModal>
    <div class="form-group">
        <div class="alert alert-warning">
            <i class="fa fa-exclamation-triangle"></i>
            <span [i18n]="'realtime-tracking.load-tracking-map.trip-details.close.modal.content'"></span>
        </div>
    </div>
</ng-template>


<ng-template #notificationModal>
    <form novalidate class="row">
        <div class="form-group row">
            <div class="col-sm-6">
                <label class="control-label"
                       [i18n]="'realtime-tracking.load-tracking-map.trip-details.notifications.load-number'"></label>
                <div class="input-group">
                    <input type="text" class="form-control" readonly [value]="trip.loadNumber">
                    <span class="input-group-btn">
                        <button class="btn btn-info" [i18n]="[{ target: 'attribute:title', key: 'copy.tooltip' }]"
                                (click)="copy(trip.loadNumber)">
                            <i class="fa fa-copy"></i>
                        </button>
                    </span>
                </div>
            </div>
            <div class="col-sm-6">
                <label class="control-label"
                       [i18n]="'realtime-tracking.load-tracking-map.trip-details.notifications.delivery-numbers'"></label>
                <div class="input-group">
                    <input type="text" class="form-control" readonly [value]="trip.deliveryNumbers.join(', ')">
                    <span class="input-group-btn">
                        <button class="btn btn-info" [i18n]="[{ target: 'attribute:title', key: 'copy.tooltip' }]"
                                (click)="copy(trip.deliveryNumbers.join(', '))">
                            <i class="fa fa-copy"></i>
                        </button>
                    </span>
                </div>
            </div>
        </div>
        <div class="form-group" [ngClass]="{ 'has-error': modalTitleInput.invalid && modalTitleInput.dirty }">
            <div class="form-group">
                <label class="control-label" for="modal-title"
                       [i18n]="'realtime-tracking.load-tracking-map.trip-details.notifications.custom.modal.title-label'"></label>
                <input name="modal-title" type="text" class="form-control input-lg" id="modal-title" appAutofocus
                       [(ngModel)]="modalNotificationTitle" #modalTitleInput="ngModel"
                       required>
                <label class="error"
                       *ngIf="modalTitleInput.dirty && modalTitleInput.errors && modalTitleInput.errors.required"
                       [i18n]="'validation.required'"></label>
            </div>

            <div class="form-group">
                <label class="control-label" for="modal-message"
                       [i18n]="'realtime-tracking.load-tracking-map.trip-details.notifications.custom.modal.message-label'"></label>
                <input name="modal-message" type="text" class="form-control input-lg" id="modal-message"
                       [(ngModel)]="modalNotificationMessage" #modalMessageInput="ngModel"
                       required>
                <label class="error"
                       *ngIf="modalMessageInput.dirty && modalMessageInput.errors && modalMessageInput.errors.required"
                       [i18n]="'validation.required'"></label>
            </div>

            <div class="form-group">
                <div class="alert alert-warning">
                    <i class="fa fa-exclamation-triangle"></i>
                    <span
                        [i18n]="'realtime-tracking.load-tracking-map.trip-details.notifications.custom.warning-message'"></span>
                </div>
            </div>
        </div>
    </form>
</ng-template>
